import { Component, ElementRef, Inject, OnInit, Optional, QueryList, ViewChildren } from '@angular/core';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { IPDService } from '../Services/ipdServices.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CounselorPreOpInstructionDetail, CounselorPreOpInvestigation, CounselorPreOpMedicineDetail, GetCounselorCheckList, GetInstructionTemplateMaster, GetInvestigationTemplateMaster, GetMedicianTemplateMaster, GetPreOpTemplateMaster } from '../models/get-pre-op-template-master';
import { InvestigationServicesComponent } from 'app/EMR/Doctor/investigation-services/investigation-services.component';
import { MedicineTemplateComponent } from 'app/EMR/template_help/medicine-template/medicine-template.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-preop-detail',
  templateUrl: './preop-detail.component.html',
  styleUrls: ['./preop-detail.component.scss']
})
export class PreopDetailComponent implements OnInit {
  templateMaster: GetPreOpTemplateMaster[] = [];
  MediciantemplateMaster: GetMedicianTemplateMaster[] = [];
  InvestigationtemplateMaster: GetInvestigationTemplateMaster[] = [];
  InstructiontemplateMaster: GetInstructionTemplateMaster[] = [];
  MediciantemplateDeleteArray: GetMedicianTemplateMaster[] = [];
  InvestigationtemplateDeleteArray: GetInvestigationTemplateMaster[] = [];
  InstructiontemplateDeleteArray: GetInstructionTemplateMaster[] = [];
  CounselorCheckList: GetCounselorCheckList[] = [];
  CounselorInvestigation: CounselorPreOpInvestigation[] = [];
  CounselorMedicineDetail: CounselorPreOpMedicineDetail[] = [];
  CounselorInstructionDetail: CounselorPreOpInstructionDetail[] = [];
  CounselorCheckDeleteArray: GetCounselorCheckList[] = [];
  CounselorInvestigationDeleteArray: CounselorPreOpInvestigation[] = [];
  CounselorMedicineDetailDeleteArray: CounselorPreOpMedicineDetail[] = [];
  CounselorInstructionDetailDeleteArray: CounselorPreOpInstructionDetail[] = [];
  CounspreopDisable: boolean = true;
  PDcheckedyes: boolean = false;
  PDcheckedno: boolean = false;
  PDcheckednone: boolean = false;
  SelectListRecord: any;
  indexdataCons: any;
  filterTemp:any;
  @ViewChildren("defaultInsCons") defaultConsInstruction: QueryList<ElementRef>;
  @ViewChildren("defaultTemp") defaulttemplate: QueryList<ElementRef>;
  @ViewChildren("defaultIns") defaultInstruction: QueryList<ElementRef>;
  constructor(public dialog: MatDialog, public opdvisitService: OpdVisitService, public authService: AuthService, public emrservice: EMRService, public ipdService: IPDService, public dashboardService: DashboardService, public dialogRef: MatDialogRef<PreopDetailComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.PDcheckedyes = false;
    this.PDcheckedno = false;
    this.PDcheckednone = false;
    this.GetDosageMaster(0,0,0);
    this.getCounselorPreOpDetail(this.data.consid);
  }
  closedialog() {
    this.dialogRef.close();
  }
  dosedataArray: any = [];
  GetDosageMaster(doseid,type,seachtype) {
    this.emrservice.GetDosageMaster(doseid,type,seachtype).subscribe((item) => {
      this.dosedataArray = [];
      this.dosedataArray = item;
    });
  }
  getCounselorPreOpDetail(id) {
    this.GetCounselorCheckListByCounselorId(id);
    this.GetCounselorPreOpInvestigationByCounselorId(id);
    this.GetCounselorPreOpMedicineDetailByCounselorId(id);
    this.GetCounselorPreOpInstructionDetailByCounselorId(id);
    this.clearDeletearray();
  }
  GetCounselorCheckListByCounselorId(id: any) {
    this.CounselorCheckList = [];
    this.ipdService
      .GetCounselorCheckListByCounselorId(id)
      .subscribe((data: any[]) => {
        const checkYesvalue = data.filter(
          (item) => item.actualValue.toLocaleLowerCase() == "yes"
        );
        const checkNovalue = data.filter(
          (item) => item.actualValue.toLocaleLowerCase() == "no"
        );
        const checkNonevalue = data.filter(
          (item) => item.actualValue.toLocaleLowerCase() == "none"
        );
        if (data.length == checkYesvalue.length) {
          this.PDcheckedyes = true;
          this.PDcheckedno = false;
          this.PDcheckednone = false;
        } else if (data.length == checkNovalue.length) {
          this.PDcheckedyes = false;
          this.PDcheckedno = true;
          this.PDcheckednone = false;
        } else if (data.length == checkNonevalue.length) {
          this.PDcheckedyes = false;
          this.PDcheckedno = false;
          this.PDcheckednone = true;
        } else {
          this.PDcheckedyes = false;
          this.PDcheckedno = false;
          this.PDcheckednone = false;
        }
        this.CounselorCheckList = data;
      });
  }
  GetCounselorPreOpInvestigationByCounselorId(id: any) {
    this.CounselorInvestigation = [];
    this.ipdService
      .GetCounselorPreOpInvestigationByCounselorId(id)
      .subscribe((data: any[]) => {
        this.CounselorInvestigation = data;
      });
  }
  GetCounselorPreOpMedicineDetailByCounselorId(id: any) {
    this.CounselorMedicineDetail = [];
    this.ipdService
      .GetCounselorPreOpMedicineDetailByCounselorId(id)
      .subscribe((data: any[]) => {
        this.CounselorMedicineDetail = data;
      });
  }
  GetCounselorPreOpInstructionDetailByCounselorId(id: any) {
    this.CounselorInstructionDetail = [];
    this.ipdService
      .GetCounselorPreOpInstructionDetailByCounselorId(id)
      .subscribe((data: any[]) => {
        this.CounselorInstructionDetail = data;
      });
  }
  clearAllcounselorPreOpdetail() {
    this.CounspreopDisable = true;
    this.CounselorCheckList = [];
    this.CounselorInvestigation = [];
    this.CounselorMedicineDetail = [];
    this.CounselorInstructionDetail = [];
    this.CounselorInvestigationDeleteArray = [];
    this.CounselorMedicineDetailDeleteArray = [];
    this.CounselorInstructionDetailDeleteArray = [];
  }
  clearDeletearray() {
    this.CounselorInvestigationDeleteArray = [];
    this.CounselorMedicineDetailDeleteArray = [];
    this.CounselorInstructionDetailDeleteArray = [];
  }
  checkCounselorInstruction() {
    this.CounspreopDisable = false;
  }
  CounselorInstructionDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorInstructionDetail.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorInstructionDetailDeleteArray.push(row);
      this.CounselorInstructionDetailDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorInstructionDetailDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  getPreOpDetailvalue(value) {
    this.CounspreopDisable = false;
    this.CounselorCheckList.map((item) => (item.actualValue = value));
    this.CounselorCheckList.map((item) => (item.isEdit = true));
    const checkYesvalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.CounselorCheckList.length == checkYesvalue.length) {
      this.PDcheckedyes = true;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNovalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = true;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNonevalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = true;
    } else {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    }
  }
  getPreDetailSelectvalue(event, i) {
    this.CounselorCheckList[i].isEdit =
      this.CounselorCheckList[i].pK_TranId > 0 ? true : false;
    this.CounselorCheckList[i].actualValue = event.value;
    const checkYesvalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "yes"
    );
    const checkNovalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "no"
    );
    const checkNonevalue = this.CounselorCheckList.filter(
      (item) => item.actualValue.toLocaleLowerCase() == "none"
    );
    if (this.CounselorCheckList.length == checkYesvalue.length) {
      this.PDcheckedyes = true;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNovalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = true;
      this.PDcheckednone = false;
    } else if (this.CounselorCheckList.length == checkNonevalue.length) {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = true;
    } else {
      this.PDcheckedyes = false;
      this.PDcheckedno = false;
      this.PDcheckednone = false;
    }
  }
  PreDetailcheckstatus(option, i) {
    if (this.CounselorCheckList[i].actualValue != null) {
      return (
        this.CounselorCheckList[i].actualValue.toLocaleLowerCase() ==
        option.toLocaleLowerCase()
      );
    } else {
      return false;
    }
  }
  selectPreOpDetail(row, i) {
    this.CounspreopDisable = false;
    this.SelectListRecord = row;
    this.indexdataCons = this.SelectListRecord.pK_TranId;
    this.CounselorCheckList[i] = this.SelectListRecord;
  }
  newservice(type) {
    const dialogRef = this.dialog.open(InvestigationServicesComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      maxHeight: "90%",
      width: "80%",
    });
    dialogRef.afterClosed().subscribe((result) => {
       if (type == 2) {
        this.templateMasterDisable = false;
        let newresult = this.emrservice.selectedInvestigationRow.reduce(
          (unique, o) => {
            if (
              !unique.some(
                (obj) =>
                  obj.serviceName === o.serviceName &&
                  obj.FK_ServiceId === o.FK_ServiceId
              )
            ) {
              unique.push(o);
            }
            return unique;
          },
          []
        );
        newresult?.forEach((item) => {
          this.InvestigationtemplateMaster.push({
            pK_TranID: 0,
            fK_TemplateID: this.masterTemplateId,
            fK_ServiceId: item.serviceId,
            serviceName: item.serviceName,
            pK_SynchId: null,
            isActive: true,
            isEdit: false,
            isDelete: false,
          });
        });
        if (this.InvestigationtemplateMaster.length > 1) {
          this.InvestigationtemplateMaster =
            this.InvestigationtemplateMaster.reduce((unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    obj.fK_ServiceId === o.fK_ServiceId
                )
              ) {
                unique.push(o);
              }
              return unique;
            }, []);
        }
        // if (newresult.length > 0) {
        //
        //   this.InvestigationtemplateMaster = this.InvestigationtemplateMaster.concat(this.InvestigationtemplateMaster);

        // }
      }else if (type == 3) {
        this.CounspreopDisable = false;
        let newresult = this.emrservice.selectedInvestigationRow.reduce(
          (unique, o) => {
            if (
              !unique.some(
                (obj) =>
                  obj.serviceName === o.serviceName &&
                  obj.FK_ServiceId === o.FK_ServiceId
              )
            ) {
              unique.push(o);
            }
            return unique;
          },
          []
        );
        newresult?.forEach((item) => {
          this.CounselorInvestigation.push({
            pK_TranId: 0,
            fK_CounsID: this.data.consid,
            fK_ServiceId: item.serviceId,
            serviceName: item.serviceName,
            pK_SynchId: null,
            result: item.result,
            eye: item.eye,
            isEdit: item.pk_TranId > 0 ? true : false,
            isDelete: false,
          });
        });
        if (this.CounselorInvestigation.length > 1) {
          this.CounselorInvestigation = this.CounselorInvestigation.reduce(
            (unique, o) => {
              if (
                !unique.some(
                  (obj) =>
                    obj.serviceName === o.serviceName &&
                    obj.fK_ServiceId === o.fK_ServiceId
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
        }

      }
    });
  }
  commentChange(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;

    if (e != null) {
      this.CounselorInvestigation[index].result = e;
      this.CounselorInvestigation[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorInvestigation[index].isDelete = false;
    }
  }
  onSitechangeIns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorInvestigation[index].eye = e;
      this.CounselorInvestigation[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorInvestigation[index].isDelete = false;
    }
  }
  CounselorInvestDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorInvestigation.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorInvestigationDeleteArray.push(row);
      this.CounselorInvestigationDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorInvestigationDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  onQtychangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].qty = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onDosechangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      let doseid = this.dosedataArray.filter((item) => item.dosageCode == e);
      this.CounselorMedicineDetail[index].fK_DosageId = doseid[0].pK_DosageId;
      this.CounselorMedicineDetail[index].dosageCode = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  ondaysChangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].days = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onUnitchangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].unit = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onSitechangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].eye = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  onremarkschangeCOuns(e: any, index: number, idcheck) {
    this.CounspreopDisable = false;
    if (e != null) {
      this.CounselorMedicineDetail[index].remarks = e;
      this.CounselorMedicineDetail[index].isEdit = idcheck > 0 ? true : false;
      this.CounselorMedicineDetail[index].isDelete = false;
    }
  }
  CounselorMedicineDeleteRow(row, index: number) {
    this.CounspreopDisable = false;

    this.CounselorMedicineDetail.splice(index, 1);
    if (row.pK_TranId > 0) {
      this.CounselorMedicineDetailDeleteArray.push(row);
      this.CounselorMedicineDetailDeleteArray.map(
        (item) => (item.isEdit = true)
      );
      this.CounselorMedicineDetailDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  onQtychangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].qty = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onDosechangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      let doseid = this.dosedataArray.filter((item) => item.dosageCode == e);
      this.MediciantemplateMaster[index].fK_DosageId = doseid[0].pK_DosageId;
      this.MediciantemplateMaster[index].dosageCode = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  ondaysChangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].days = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onUnitchangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].unit = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  onremarkschangeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].remakrs = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  medicineTypeTemp(e: any, index: number, idcheck) {
    this.templateMasterDisable = false;
    if (e != null) {
      this.MediciantemplateMaster[index].medicineType = e;
      this.MediciantemplateMaster[index].isEdit = idcheck > 0 ? true : false;
      this.MediciantemplateMaster[index].isDelete = false;
    }
  }
  checkInstruction(event) {
    this.templateMasterDisable = false;
  }
  InstructiontemplateDeleteRow(row, index: number) {
    this.templateMasterDisable = false;
    this.InstructiontemplateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.InstructiontemplateDeleteArray.push(row);
      this.InstructiontemplateDeleteArray.map((item) => (item.isEdit = true));
      this.InstructiontemplateDeleteArray.map((item) => (item.isDelete = true));
    }
  }
  InstructionAddRow() {
    this.templateMasterDisable = false;
    const templist = {
      pK_TranID: 0,
      fK_TemplateId: this.masterTemplateId,
      instruction: "",
      isActive: true,
      isEdit: false,
      isDelete: false,
    };
    this.InstructiontemplateMaster.push(templist);
    this.defaultInstruction.changes.pipe(take(1)).subscribe({
      next: (changes) => changes.last.nativeElement.focus(),
    });
  }
  CounselorInstructionAddRow() {
    this.CounspreopDisable = false;
    const templist = {
      pK_TranId: 0,
      fK_CounsID: this.data.consid,
      instructions: "",
      isActive: true,
      isEdit: false,
      isDelete: false,
    };
    this.CounselorInstructionDetail.push(templist);
    this.defaultConsInstruction.changes.pipe(take(1)).subscribe({
      next: (changes) => changes.last.nativeElement.focus(),
    });
  }
  //medinice template
  OpenMediniceTemplate(type) {
    const dialogRef = this.dialog.open(MedicineTemplateComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "90%",
      width: "90%",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.length > 0) {
        if (type == 5) {
          if (result.length > 0) {
            this.CounspreopDisable = false;
            result?.forEach((item) => {
              this.CounselorMedicineDetail.push({
                pK_TranId: 0,
                fK_CounsID: this.data.consid,
                fK_MedicineId: item.pK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.daysUnit,
                remarks: item.remarks,
                medicineName: item.medicineName,
                dosageCode: item.dosageCode,
                medicineType: item.type,
                pK_SynchId: null,
                isEdit: false,
                isDelete: false,
              });
            });

            if (this.CounselorMedicineDetail.length > 1) {
              this.CounselorMedicineDetail =
                this.CounselorMedicineDetail.reduce((unique, o) => {
                  if (
                    !unique.some((obj) => obj.medicineName === o.medicineName)
                  ) {
                    unique.push(o);
                  }
                  return unique;
                }, []);
            }
          }
        }else if (type == 4) {
          if (result.length > 0) {
            this.templateMasterDisable = false;
            result?.forEach((item) => {
              this.MediciantemplateMaster.push({
                pK_TranID: 0,
                fK_TemplateId: this.masterTemplateId,
                fK_MedicineId: item.pK_MedicineId,
                qty: item.qty,
                fK_DosageId: item.fK_DosageId,
                days: item.days,
                unit: item.daysUnit,
                remakrs: item.remarks,
                medicineName: item.medicineName,
                dosageCode: item.dosageCode,
                medicineType: item.type,
                pK_SynchId: null,
                isActive: true,
                isEdit: false,
                isDelete: false,
              });
            });
         
            if (this.MediciantemplateMaster.length > 1) {
              this.MediciantemplateMaster = this.MediciantemplateMaster.reduce(
                (unique, o) => {
                  if (
                    !unique.some((obj) => obj.medicineName === o.medicineName)
                  ) {
                    unique.push(o);
                  }
                  return unique;
                },
                []
              );
            }
          }
        }
      }
    });
  }

  //save data
  SaveCounselorPreOpDetail(event) {
    const button =
      event.srcElement.disabled === undefined
        ? event.srcElement.parentElement
        : event.srcElement;
    button.setAttribute("disabled", true);
    this.CounselorCheckList?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorCheckList.map((item) => (item.isEdit = true));
        this.CounselorCheckList.map((item) => (item.isDelete = false));
      }
    });
    this.CounselorInvestigation?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorInvestigation.map((item) =>
          item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
        );
        this.CounselorInvestigation.map((item) => (item.isDelete = false));
      }
    });

    this.CounselorMedicineDetail?.forEach((item) => {
      if (item.pK_TranId > 0) {
        this.CounselorMedicineDetail.map((item) =>
          item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
        );
        this.CounselorMedicineDetail.map((item) => (item.isDelete = false));
      }
    });

    this.CounselorInstructionDetail?.forEach((item) => {
      this.CounselorInstructionDetail.map((item) =>
        item.pK_TranId > 0 ? (item.isEdit = true) : (item.isEdit = false)
      );
      this.CounselorInstructionDetail.map((item) => (item.isDelete = false));
    });

    let PayLoad = {
      CounselorCheckList: this.CounselorCheckList,

      CounselorPreOpInvestigation: this.CounselorInvestigation.concat(
        this.CounselorInvestigationDeleteArray
      ),

      CounselorPreOpMedicineDetail: this.CounselorMedicineDetail.concat(
        this.CounselorMedicineDetailDeleteArray
      ),

      CounselorPreOpInstructionDetail: this.CounselorInstructionDetail.concat(
        this.CounselorInstructionDetailDeleteArray
      ),
    };

    this.ipdService.InsertCounselorPreOpDetail(PayLoad).subscribe(
      (data) => {
        this.CounspreopDisable = true;
        if (data.statusCode == 1) {
          this.getCounselorPreOpDetail(this.data.consid);
          this.clearDeletearray();
          this.dashboardService.openSnackBar(
            " Record Saved Successfully",
            "OK"
          );
        }
      },
      (err) => {
        this.dashboardService.openSnackBar("API FAILED", "OK");
      }
    );
  }
  getPreOpTemplateMaster(transId: any) {
    this.templateMaster = [];
    this.ipdService.GetPreOpTemplateMaster(transId).subscribe((data: any[]) => {
      this.templateMaster = data;
    });
  }
  templateMasterDisable: boolean = true;
  templateNameenter() {
    this.templateMasterDisable = false;
  }
  TemplateAddRow() {
    this.templateMasterDisable = false;
    this.MediciantemplateMaster = [];
    this.InvestigationtemplateMaster = [];
    this.InstructiontemplateMaster = [];
    const templist = {
      pK_TranID: 0,
      fK_SurgeryId: null,
      fK_DiagnosisId: null,
      templateName: "",
      isActive: true,
      pK_SynchId: null,
      isEdit: false,
      isDelete: false,
    };
    this.templateMaster.push(templist);
    this.defaulttemplate.changes.pipe(take(1)).subscribe({
      next: (changes) => changes.last.nativeElement.focus(),
    });
    this.selectTemplateRow(templist, this.templateMaster.length - 1);
  }
  InvestigationtemplateDeleteRow(row, index: number) {
    this.templateMasterDisable = false;
    this.InvestigationtemplateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.InvestigationtemplateDeleteArray.push(row);
      this.InvestigationtemplateDeleteArray.map((item) => (item.isEdit = true));
      this.InvestigationtemplateDeleteArray.map(
        (item) => (item.isDelete = true)
      );
    }
  }
  TemplatedeleteRow(event, row, index: number) {
    this.templateMasterDisable = false;
    this.templateMaster.splice(index, 1);
    if (row.pK_TranID > 0) {
      this.templateMaster.push(row);
      this.templateMaster[index].isEdit = true;
      this.templateMaster[index].isDelete = true;
      this.MediciantemplateMaster.map((item) => (item.isEdit = true));
      this.MediciantemplateMaster.map((item) => (item.isDelete = true));
      this.InvestigationtemplateMaster.map((item) => (item.isEdit = true));
      this.InvestigationtemplateMaster.map((item) => (item.isDelete = true));
      this.InstructiontemplateMaster.map((item) => (item.isEdit = true));
      this.InstructiontemplateMaster.map((item) => (item.isDelete = true));
      this.SavePreOpTemplateMaster(1);
    }
  }
  tempobj: any = {};
  SavePreOpTemplateMaster(type, event?: any) {
    this.tempobj = {};
    if (type != 1) {
      const tempBlank = this.templateMaster.filter(
        (item) => item.templateName == "" || item.templateName == null
      );
      const InstructionBlank = this.InstructiontemplateMaster.filter(
        (item) => item.instruction == "" || item.instruction == null
      );
      if (tempBlank.length > 0) {
        this.dashboardService.openSnackBar("Please Add Template Name", "ok");
      } else {
        if (InstructionBlank.length > 0) {
          this.dashboardService.openSnackBar("Please Add Instruction", "ok");
        } else {
          const button =
            event.srcElement.disabled === undefined
              ? event.srcElement.parentElement
              : event.srcElement;
          button.setAttribute("disabled", true);

          var template = this.templateMaster.filter(
            (item) => item.pK_TranID == this.masterTemplateId
          );

          this.tempobj = template[0];
          if (this.tempobj.pK_TranID == 0) {
            this.tempobj.isEdit = false;
            this.tempobj.isDelete = false;
          } else {
            this.tempobj.isEdit = true;
            this.tempobj.isDelete = false;
          }
          for (var i = 0; i < this.InstructiontemplateMaster.length; i++) {
            if (this.InstructiontemplateMaster[i].pK_TranID !== 0) {
              this.InstructiontemplateMaster[i].isEdit = true;
              this.InstructiontemplateMaster[i].isDelete = false;
            } else {
              this.InstructiontemplateMaster[i].isEdit = false;
              this.InstructiontemplateMaster[i].isDelete = false;
            }
          }

          let PayLoad = {
            PreOpTemplateMaster: this.tempobj,

            PreOpTemplateInvestigationDetail:
              this.InvestigationtemplateMaster.concat(
                this.InvestigationtemplateDeleteArray
              ),

            PreOpTemplatePrescriptionDetail: this.MediciantemplateMaster.concat(
              this.MediciantemplateDeleteArray
            ),

            PreOpTemplateInstructionDetail:
              this.InstructiontemplateMaster.concat(
                this.InstructiontemplateDeleteArray
              ),
          };
          this.ipdService.InsertPreOpTemplateMaster(PayLoad).subscribe(
            (data) => {
              button.removeAttribute("disabled");
              this.templateMasterDisable = true;
              if (data.statusCode == 1) {
                this.getPreOpTemplateMaster(0);
                this.clearTemplateDeletearray();
                this.dashboardService.openSnackBar(
                  " Record Saved Successfully",
                  "OK"
                );
              }
            },
            (err) => {
              this.dashboardService.openSnackBar("API FAILED", "OK");
            }
          );
        }
      }
    } else {
      var template = this.templateMaster.filter(
        (item) => item.isDelete == true
      );
      this.tempobj = template[0];
      let PayLoad = {
        PreOpTemplateMaster: this.tempobj,

        PreOpTemplateInvestigationDetail: this.InvestigationtemplateMaster,

        PreOpTemplatePrescriptionDetail: this.MediciantemplateMaster,

        PreOpTemplateInstructionDetail: this.InstructiontemplateMaster,
      };
      this.ipdService.InsertPreOpTemplateMaster(PayLoad).subscribe(
        (data) => {
          if (data.statusCode == 1) {
            this.InvestigationtemplateMaster = [];
            this.MediciantemplateMaster = [];
            this.InstructiontemplateMaster = [];
            this.templateMasterDisable = true;
            this.getPreOpTemplateMaster(0);
            this.dashboardService.openSnackBar(
              " Record Deleted Successfully",
              "OK"
            );
          }
        },
        (err) => {
          this.dashboardService.openSnackBar("API FAILED", "OK");
        }
      );
    }
  }
  preOperativeWorkup() {
    if (this.templateMaster.length > 0) {
      this.selectTemplateRow(this.templateMaster[0], 0);
    }
    document.getElementById("preOperativeWorkup").style.display = "block";
  }
  selectedTemprow: any;
  rowClickedTemplate: any;
  masterTemplateId: any;
  selectTemplateRow(row, i) {
    this.MediciantemplateMaster = [];
    this.InvestigationtemplateMaster = [];
    this.InstructiontemplateMaster = [];
    this.selectedTemprow = row;
    this.rowClickedTemplate = i;
    this.masterTemplateId = row.pK_TranID;
    if (this.masterTemplateId != 0) {
      this.GetPreOpTemplatePrescriptionDetailByIdByTemplateId();
      this.GetPreOpTemplateInvestigationDetailByIdByTemplateId();
      this.GetPreOpTemplateInstructionDetailByIdByTemplateId();
      this.clearTemplateDeletearray();
    }
  }
  clearTemplateDeletearray() {
    this.MediciantemplateDeleteArray = [];
    this.InvestigationtemplateDeleteArray = [];
    this.InstructiontemplateDeleteArray = [];
  }
  GetPreOpTemplatePrescriptionDetailByIdByTemplateId() {
    this.MediciantemplateMaster = [];
    this.ipdService
      .GetPreOpTemplatePrescriptionDetailByIdByTemplateId(this.masterTemplateId)
      .subscribe((data: any[]) => {
       
        this.MediciantemplateMaster = data.map((item) => ({
          daysUnit: item.unit,
          type: item.medicineType,
          ...item,
        }));
      });
  }
  GetPreOpTemplateInvestigationDetailByIdByTemplateId() {
    this.InvestigationtemplateMaster = [];
    this.ipdService
      .GetPreOpTemplateInvestigationDetailByIdByTemplateId(
        this.masterTemplateId
      )
      .subscribe((data: any[]) => {
        this.InvestigationtemplateMaster = data;
      });
  }

  GetPreOpTemplateInstructionDetailByIdByTemplateId() {
    this.InstructiontemplateMaster = [];
    this.ipdService
      .GetPreOpTemplateInstructionDetailByIdByTemplateId(this.masterTemplateId)
      .subscribe((data: any[]) => {
        this.InstructiontemplateMaster = data;
      });
  }
  cancelpreOperativeWorkup() {
    this.templateMaster = [];
    this.getPreOpTemplateMaster(0);
    document.getElementById("preOperativeWorkup").style.display = "none";
  }
  updatePreOpTemplateMaster() {
    this.CounspreopDisable = false;
    this.InvestigationtemplateMaster?.forEach((item) => {
      this.CounselorInvestigation.push({
        pK_TranId: 0,
        fK_CounsID: this.data.consid,
        fK_ServiceId: item.fK_ServiceId,
        serviceName: item.serviceName,
        pK_SynchId: null,
        isEdit: false,
        isDelete: false,
      });
    });
    // this.CounselorMedicineDetail = this.CounselorMedicineDetail.concat(this.MediciantemplateMaster);
    this.MediciantemplateMaster?.forEach((item) => {
      this.CounselorMedicineDetail.push({
        pK_TranId: 0,
        fK_CounsID: this.data.consid,
        fK_MedicineId: item.fK_MedicineId,
        qty: item.qty,
        fK_DosageId: item.fK_DosageId,
        days: item.days,
        unit: item.unit,
        remarks: item.remakrs,
        medicineName: item.medicineName,
        dosageCode: item.dosageCode,
        medicineType: item.medicineType,
        pK_SynchId: null,
        isEdit: false,
        isDelete: false,
      });
    });
    // this.CounselorInstructionDetail = this.CounselorInstructionDetail.concat(this.InstructiontemplateMaster);
    this.InstructiontemplateMaster?.forEach((item) => {
      this.CounselorInstructionDetail.push({
        pK_TranId: 0,
        fK_CounsID: this.data.consid,
        instructions: item.instruction,
        isActive: item.isActive,
        isEdit: false,
        isDelete: false,
      });
    });
    this.cancelpreOperativeWorkup();
  }
}
